import React, { useState } from 'react';
import { aaiApi } from '../../services/aaiApi';
import { useAsync } from '../aai/useAsync';
import type { Workspace } from '../../types/aai';
import { Field, Panel, PanelHead, Select } from '../../components/aa';
import { GrantsPanel } from './GrantsPanel';

/*
 * Super admin: pick a client, then edit what each role may see and do there.
 * A cell changed here overrides the platform default for that client only.
 */
export const ClientGrantOverrides: React.FC = () => {
  const workspaces = useAsync<{ workspaces: Workspace[] }>(() => aaiApi.getWorkspaces(), 'Could not load clients.');
  const [clientId, setClientId] = useState('');
  const list = workspaces.data?.workspaces || [];

  return (
    <div className="space-y-5">
      <Panel>
        <PanelHead
          title="Client overrides"
          desc="Platform defaults apply to every client. Pick one to change what a role may do there, or to let its owner or partner manage the grants below them."
        />
        <div className="px-5 pb-5 pt-4 md:px-6">
          <Field label="Client" className="max-w-md">
            <Select value={clientId} onChange={(e) => setClientId(e.target.value)}>
              <option value="">Choose a client</option>
              {list.map((w) => <option key={w.id} value={w.id}>{w.display_name || w.name || w.id}</option>)}
            </Select>
          </Field>
        </div>
      </Panel>
      {clientId && <GrantsPanel companyId={clientId} onlyBuiltRoles />}
    </div>
  );
};

export default ClientGrantOverrides;
